import palette from '../palette';

export default {
  errorContainer: {
    maxWidth: '500px',
    margin: '0 auto',
    '& p': {
      marginBottom: '15px',
    },
    '& a': {
      color: palette.primary,
    },
  },
  sessionExpiredContainer: {
    maxWidth: '500px',
    margin: '0 auto',
    '& h1': {
      marginBottom: '8px',
    },
    '& p': {
      marginBottom: '15px',
    },
    '&:focus': {
      outline: 'none',
    },
  },
};
